webpackJsonp([9],{

/***/ 115:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(228)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(176),
  /* template */
  __webpack_require__(255),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 127:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'ImageFrame',
    props: ['url']
});

/***/ }),

/***/ 128:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(99)(true);
// imports


// module
exports.push([module.i, "@media only screen and (max-width:768px){iframe[data-v-44d2b8da]{width:85vw}}iframe[data-v-44d2b8da]{width:100%}", "", {"version":3,"sources":["/opt/build/repo/cowork-panel/src/components/ImageFrame.vue"],"names":[],"mappings":"AACA,yCACA,wBACI,UAAY,CACf,CACA,AACD,wBACE,UAAY,CACb","file":"ImageFrame.vue","sourcesContent":["\n@media only screen and (max-width: 768px) {\niframe[data-v-44d2b8da] {\n    width: 85vw;\n}\n}\niframe[data-v-44d2b8da] {\n  width: 100%;\n}\n\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 129:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(128);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(100)("63c760ff", content, true, {});

/***/ }),

/***/ 130:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(129)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(127),
  /* template */
  __webpack_require__(131),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-44d2b8da",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 131:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('iframe', {
    staticStyle: {
      "border": "0"
    },
    attrs: {
      "rel": "dns-prefetch",
      "src": this.url,
      "loading": "lazy",
      "title": "coworking bratislava 360",
      "height": "500",
      "frameborder": "0",
      "allowfullscreen": ""
    }
  })
},staticRenderFns: []}

/***/ }),

/***/ 176:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ImageFrame__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ImageFrame___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__ImageFrame__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    ImageFrame: __WEBPACK_IMPORTED_MODULE_0__ImageFrame___default.a
  },
  name: 'meetingroom',
  metaInfo: {
    title: 'Private and shared office in downtown of Bratislava'
  },
  data: function data() {
    return {
      href: {
        iframes: ["https://www.google.com/maps/embed?pb=!4v1548615947594!6m8!1m7!1sCAoSLEFGMVFpcE1uOUhxclBDNFJtN0VsaDRfYnZzbFRKaldSdGlJZER3cTR6Tkcz!2m2!1d48.14466111111111!2d17.1154!3f272.452135499486!4f-1.9685896130948208!5f0.4000000000000002"]
      }
    };
  }
});

/***/ }),

/***/ 204:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(99)(true);
// imports


// module
exports.push([module.i, ".button.is-black.is-block.is-large.meeting{background-image:-webkit-gradient(linear,left bottom,right top,from(#b60cf6),color-stop(#9316e5),color-stop(#711ad4),color-stop(#4c1ac1),to(#1e19ae));background-image:-webkit-linear-gradient(left bottom,#b60cf6,#9316e5,#711ad4,#4c1ac1,#1e19ae);background-image:-o-linear-gradient(left bottom,#b60cf6,#9316e5,#711ad4,#4c1ac1,#1e19ae);background-image:linear-gradient(to right top,#b60cf6,#9316e5,#711ad4,#4c1ac1,#1e19ae)}.notification{padding:0}", "", {"version":3,"sources":["/opt/build/repo/cowork-panel/src/components/PrivateOffice.vue"],"names":[],"mappings":"AACA,2CACE,sJAA8J,AAC9J,8FAAoG,AACpG,yFAA+F,AAC/F,sFAA6F,CAC9F,AACD,cACA,SAAW,CACV","file":"PrivateOffice.vue","sourcesContent":["\n.button.is-black.is-block.is-large.meeting {\n  background-image: -webkit-gradient(linear, left bottom, right top, from(#b60cf6), color-stop(#9316e5), color-stop(#711ad4), color-stop(#4c1ac1), to(#1e19ae));\n  background-image: -webkit-linear-gradient(left bottom, #b60cf6, #9316e5, #711ad4, #4c1ac1, #1e19ae);\n  background-image: -o-linear-gradient(left bottom, #b60cf6, #9316e5, #711ad4, #4c1ac1, #1e19ae);\n  background-image: linear-gradient(to right top, #b60cf6, #9316e5, #711ad4, #4c1ac1, #1e19ae);\n}\n.notification {\npadding: 0;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 228:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(204);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(100)("b5d49dc2", content, true, {});

/***/ }),

/***/ 255:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "meetingroom"
  }, [_c('div', {
    staticClass: "tile is-ancestor"
  }, [_c('div', {
    staticClass: "tile is-parent is-12"
  }, [_c('article', {
    staticClass: "tile is-child"
  }, [_c('figure', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/meetingroom/waomeeting-01-4.jpg",
      "alt": "meeting room bratislava cowork"
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "tile is-ancestor"
  }, [_c('div', {
    staticClass: "tile is-vertical is-6"
  }, [_c('div', {
    staticClass: "tile"
  }, [_c('div', {
    staticClass: "tile is-parent is-vertical"
  }, [_c('article', {
    staticClass: "tile is-child"
  }, [_c('figure', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/cowork/women_coworkers.jpg",
      "alt": "private office room bratislava cowork"
    }
  })])]), _vm._v(" "), _c('article', {
    staticClass: "tile is-child"
  }, [_c('figure', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/cowork/focus_room_coworking_bratislava.jpg",
      "alt": "street view bratislava cowork"
    }
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "tile is-parent is-size-4"
  }, [_c('article', {
    staticClass: "tile is-child notification is-black"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("💼 Private Office Dunajska")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('p', [_vm._v("🌃 24/7 access")]), _vm._v(" "), _c('p', [_vm._v("🔑 Dedicated office with all basic equipment (tables, chairs)")]), _vm._v(" "), _c('p', [_vm._v("⚡️ Ultra-fast Internet")]), _vm._v(" "), _c('p', [_vm._v("🔇 Accoustically insulated")]), _vm._v(" "), _c('p', [_vm._v("🚴‍♀️ Bicycle parking U-rack")]), _vm._v(" "), _c('p', [_vm._v("🤝 Meeting Rooms")]), _vm._v(" "), _c('p', [_vm._v("📍 Downtown location, Dunajska 14, Bratislava")]), _vm._v(" "), _c('p', [_vm._v("🥗 Lot of food options around")]), _vm._v(" "), _c('p', [_vm._v("🚗 Parking available (paid extra)")]), _vm._v(" "), _c('p', [_vm._v("📬 Company address and postal service (paid extra)")]), _vm._v(" "), _c('p', [_vm._v("💞 By renting our private office you are supporting community")]), _vm._v(" "), _c('p', [_vm._v("🕰 Available on Q1 2020")])]), _vm._v(" "), _c('div', {
    staticClass: "btn-container"
  }, [_c('a', {
    staticClass: "button is-black is-block is-large meeting",
    attrs: {
      "href": "https://docs.google.com/forms/d/e/1FAIpQLSd1WbCPxlLyeKyDHNMLFCHCyjOnz946WjCIlDPAq4XIE_8eKQ/viewform"
    }
  }, [_vm._v("\n              Submit your interest")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "tile is-ancestor"
  }, [_c('div', {
    staticClass: "tile is-parent"
  }, [_c('article', {
    staticClass: "tile is-child"
  }, [_c('figure', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/meetingroom/pb-02.jpg",
      "alt": "meeting room bratislava cowork"
    }
  })])])])])])
}]}

/***/ })

});


// WEBPACK FOOTER //
// static/js/9.985db5febfad5849552b.js